var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Prop, Vue } from 'vue-property-decorator';
import LoaderCard from '../loader-card/LoaderCard';
import { SkillCategory, SkillCategoryIncludes } from '@/models/SkillCategory';
import { Portfolio } from '@/models/Portfolio';
import { RolesEnum } from '@/items/Roles';
let AddSkillsetDialog = class AddSkillsetDialog extends Vue {
    constructor() {
        super(...arguments);
        this.name = '';
        this.formValid = false;
        this.nameRules = [(v) => !!v || 'required'];
        this.selected = null;
        this.skillSets = null;
        this.isLoading = true;
    }
    // TODO: Method was not defined. When can a skillset be added?
    get canAddSkillSets() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.BOARD, RolesEnum.ROOT, RolesEnum.TEACHER]);
    }
    get canAddSkillSet() {
        return !!(!this.isLoading && this.skillSets && this.skillSets.length);
    }
    mounted() {
        //
        this.fetchSkillSets();
    }
    async addSkillCategoryToStudent() {
        if (!this.canAddSkillSet) {
            this.closeDialog();
            return;
        }
        this.$emit('add', this.selected);
        this.closeDialog();
    }
    closeDialog() {
        this.$emit('input', false);
    }
    /**
     * if isLoading = false && skillSets.length === 0;
     *
     * dont show the dropdown
     * but instead so a text and a link
     * 'All skill sets have been linked to this student'
     * You can add new SKillsets here <link to skillsets>
     */
    async fetchSkillSets() {
        this.isLoading = true;
        const skillSets = await new SkillCategory().include([SkillCategoryIncludes.SKILLS]).all();
        // Remove Empty sets and sets that are excluded
        this.skillSets = skillSets.filter((skillSet) => {
            return !!(skillSet.skills && skillSet.skills.length && !this.exludedCategories.includes(skillSet.id));
        });
        this.isLoading = false;
    }
    deleteSkillCategory() {
        this.$emit('deleteSkillCategory');
    }
    cancelDeleteCategory() {
        this.$emit('cancelDeleteCategory');
    }
};
__decorate([
    Prop({ default: () => { } }),
    __metadata("design:type", typeof (_a = typeof Portfolio !== "undefined" && Portfolio) === "function" ? _a : Object)
], AddSkillsetDialog.prototype, "portfolio", void 0);
__decorate([
    Prop({ default: () => [] }),
    __metadata("design:type", Array)
], AddSkillsetDialog.prototype, "exludedCategories", void 0);
__decorate([
    Prop({ default: false }),
    __metadata("design:type", Boolean)
], AddSkillsetDialog.prototype, "isConfirmingDeleteCategory", void 0);
AddSkillsetDialog = __decorate([
    Component({
        components: {
            LoaderCard,
        },
    })
], AddSkillsetDialog);
export default AddSkillsetDialog;
